export default __webpack_public_path__ + "static/media/5.24.73cf67d7.mp3";